// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"fb89984e","157":"1f5edae4","168":"d374ed84","702":"a01b3c07","914":"89be5aa6"}[chunkId] + ".chunk.js";
};